import React from 'react';

import { RelatedDevice } from '@portals/api/organizations';

import { DeviceAvatarWithIndicator } from './DeviceAvatarWithIndicator';

interface ChildDevicesProps {
  devices: RelatedDevice[];
}

export function ChildDevices({ devices }: ChildDevicesProps) {
  return (
    <>
      {devices.map((device) => (
        <DeviceAvatarWithIndicator key={device.id} device={device} />
      ))}
    </>
  );
}
